'use client'
import { useState, useEffect } from 'react';

const WARNING_TIME = 60 * 1000; // Show warning 1 minute before timeout

export default function SessionTimeoutAlert({ onReset }) {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const warningTimeout = setTimeout(() => {
      setShowWarning(true);
    }, 14 * 60 * 1000); // 14 minutes

    return () => clearTimeout(warningTimeout);
  }, []);

  if (!showWarning) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-white p-4 rounded-lg shadow-lg z-50 max-w-sm">
      <div className="flex flex-col gap-3">
        <p className="text-sm text-gray-600">
          Your session will expire in 1 minute. Would you like to extend it?
        </p>
        <div className="flex justify-end gap-2">
          <button
            onClick={onReset}
            className="px-4 py-2 bg-primary text-white rounded-md text-sm hover:bg-opacity-90"
          >
            Extend Session
          </button>
        </div>
      </div>
    </div>
  );
}
